import React from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import { PlusCircleFill } from "react-bootstrap-icons";
import TrainingTable from "./trainingTable";
import { useAppDispatch } from "../../store/storeRequests";
import { useNavigate } from "react-router-dom";

const Training: React.FunctionComponent = () => {
  const navigate = useNavigate();

  const handleAddNewTraining = () => {
    navigate("/training/add"); // Replace with the actual path to your form
  };

  const buttons = [
    {
      label: "Add New Training",
      theme: "warning",
      icon: <PlusCircleFill />,
      onClick: handleAddNewTraining,
    },
  ];

  return (
    <LayoutContainer title={"Training"}>
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100">
        <h2>
          <i className="page-header-icon fa fa-list"></i>
          HR Training
        </h2>

        <PageHeader buttons={buttons} />
      </div>

      <div className="training-table">
        <TrainingTable />
      </div>
    </LayoutContainer>
  );
};

export default Training;
